const DOC_EXT_RE = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx)(\?|#|$)/i;
const IMAGE_EXT_RE = /\.(jpe?g|png|gif|webp|bmp|svg|ico|avif|heic|heif|jfif)(\?|#|$)/i;

/**
 * Detect image chat attachments for inline / card preview when the API omits or mislabels mime
 * (e.g. `application/octet-stream`) but the filename or path has a known image extension.
 * Optional `previewUrl` (e.g. first `previewImages` entry) can disambiguate extensionless storage keys.
 * Document types (pdf, office) are excluded so PDFs keep the file card while using `previewImages` for the raster.
 */
export function isLikelyImageAttachment({ name, url, mimeType, previewUrl, filePath } = {}) {
    const m = String(mimeType || '').toLowerCase();
    if (m.startsWith('image/')) return true;
    if (m === 'application/pdf' || m.startsWith('application/vnd.')) return false;
    const s = `${String(name || '')} ${String(url || '')} ${String(filePath || '')}`.toLowerCase();
    if (DOC_EXT_RE.test(s)) return false;
    if (IMAGE_EXT_RE.test(s)) return true;
    const p = String(previewUrl || '').toLowerCase();
    if (p && IMAGE_EXT_RE.test(p)) return true;
    return false;
}
